export default __webpack_public_path__ + "static/media/2.d022373e.png";